/* eslint-disable react/prop-types, react/jsx-indent, react/jsx-first-prop-new-line, prefer-template */
import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { StyleSheet, css } from 'aphrodite';

import Config from 'es6/core/config';
import { partOfSpeech } from 'es6/helpers/localization';
import Row from 'es6/components/layout/row';
import Column from 'es6/components/layout/column';
import RenderIn from 'es6/components/layout/render-in';
import LoadingBox from 'es6/components/layout/loading-box';
import { decorateWithErrorPage } from 'es6/components/layout/error-decorator';
import RoundBox from 'es6/components/layout/round-box';
import Sentence from 'es6/components/items/sentence';
import Progress from 'es6/components/items/progress';
import Course from 'es6/components/items/course';
import SoundPlayer, { SOUND_PLAYER_SENTENCE } from 'es6/components/common/sound-player';

import {
  ITEM_PART_OF_SPEACH_COLOR,
  ITEM_TRANSCRIPTION_COLOR,
  ITEM_TRANSLATION_COLOR,
} from 'es6/core/styles/colors';

function ItemsContainer({ id, item, progress, loading }) {
  const transliteration = item && item.getTransliteration();
  const transcription = item && item.getTranscription();
  const translation = item && item.getTranslation();
  const sound = item && item.getSound();
  const pos = item && partOfSpeech(item.getPartOfSpeech());
  return (
    <Row>
      <Column span={8}>
        {!item ? (
            <RoundBox>
              <LoadingBox height="250px" />
            </RoundBox>
        ) : (
          <RoundBox padded>
            <div className={css(styles.head)}>
              <div className={css(styles.text)}>
                <h1>
                  {item.getText()}
                  {' '}
                  <span className={classnames({
                    [css(styles.transcription)]:   transcription,
                    [css(styles.transliteration)]: transliteration,
                  })}>
                    {transliteration || transcription}
                  </span>
                  {' '}
                  <SoundPlayer source={sound} variant={SOUND_PLAYER_SENTENCE} />
                </h1>

                <p className={css(styles.translation)}>
                  {pos && (
                      <span>
                        <span className={css(styles.partOfSpeech)}>{pos}</span>
                        {' '}
                      </span>
                    )}
                      {translation}
                </p>
              </div>
              {Config.isLoggedIn() &&
                <div className={css(styles.progress)}>
                  <Progress progress={progress} />
                </div>
              }
            </div>

            {item.goalItems.map(goalItem =>
              <Course key={goalItem.id} goal={goalItem.goal}>
                {goalItem.sentences.map(sentence =>
                  <Sentence sentence={sentence} key={sentence.getId()} />
                  )}
              </Course>
              )}

          </RoundBox>
        )}
      </Column>
      <Column span={4}>
        <RenderIn parse={parseSecondaryBannerHTML} sourceId="secondary-banner" />
      </Column>
    </Row>
  );
}

function parseSecondaryBannerHTML(html) {
  return html.replace(/<img/i, (match) =>
    match + ` class=${css(styles.secondaryBanner)}`
  );
}

const styles = StyleSheet.create({
  head: {
    display: 'flex',
    marginBottom: '45px',
  },
  text: {
    flex: '1 1 auto',
  },
  progress: {
    maxWidth: '120px',
    flex: '1 0 auto',
    marginLeft: '15px',
  },
  // for English
  transcription: {
    color: ITEM_TRANSCRIPTION_COLOR,
    fontWeight: 'normal',
    // To avoid them being read by screen readers, put the slashes in
    // with CSS
    '::before': { content: '"/"' },
    '::after': { content: '"/"' },
  },
  // for JP/ZH
  transliteration: {
    color: ITEM_TRANSCRIPTION_COLOR,
    fontWeight: 'normal',
    '::before': { content: '"["' },
    '::after': { content: '"]"' },
  },
  partOfSpeech: {
    color: ITEM_PART_OF_SPEACH_COLOR,
    textTransform: 'lowercase',
    '::before': { content: '"("' },
    '::after': { content: '")"' },
  },
  translation: {
    fontSize: '16px',
    color: ITEM_TRANSLATION_COLOR,
  },
  secondaryBanner: {
    width: '100%',
    display: 'block',
  },
});

function mapStateToProps({ items, itemsMemories }, { params: { id } }) {
  const memory = itemsMemories.getEntity(id);

  return {
    id,
    loading: items.isLoading(id),
    item: items.getEntity(id),
    error: items.getError(id),
    progress: memory ? memory.progress : 0,
  };
}

export default connect(mapStateToProps)(decorateWithErrorPage(ItemsContainer));
